import { FC } from "react";

import { ILandingInfoPanelContent } from "@ryde/utils-landings";

interface ILandingInfoPanel {
  infoPanel: ILandingInfoPanelContent;
}

export const LandingInfoPanel: FC<ILandingInfoPanel> = () => {
  return (
    <div className="landing-info-panel hidden">
      <h2>Notice</h2>
      <ul>
        <li>Some warning text here</li>
      </ul>
    </div>
  );
};
